import { render, staticRenderFns } from "./AddMessagePush.vue?vue&type=template&id=008f0875&scoped=true"
import script from "./AddMessagePush.vue?vue&type=script&lang=js"
export * from "./AddMessagePush.vue?vue&type=script&lang=js"
import style0 from "./AddMessagePush.vue?vue&type=style&index=0&id=008f0875&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008f0875",
  null
  
)

export default component.exports